import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, ArrowRightIcon, CalendarDaysIcon, CheckIcon, LeafIcon, ListChecksIcon, MonitorSmartphoneIcon, StarIcon } from 'lucide-react';
import { checkoutUrl, handleCheckoutClick } from '../utils/checkout';
const learningPoints = ['Qué significa realmente comer saludable.', 'Cómo dejar atrás las dietas extremas.', 'Cómo construir platos balanceados.', 'Cómo organizar tus comidas.', 'Cómo preparar recetas deliciosas.', 'Cómo hacer Meal Prep.', 'Cómo mantener hábitos saludables.', 'Cómo crear un plan de alimentación que puedas sostener durante años.', 'Cómo disfrutar la comida sin sentir culpa.', 'Cómo cuidar tu salud mientras disfrutas comer.'];
export function HeroSystem() {
  return <>
      <section id="inicio" className="relative overflow-hidden bg-[#f5f4ed]" data-id="element-87">
        <img src="https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=2200&q=85" alt="Cocina moderna iluminada por luz natural" className="absolute inset-0 h-full w-full object-cover opacity-[0.20]" data-id="element-88" />
        <div className="relative mx-auto grid min-h-[760px] max-w-7xl items-center gap-12 px-5 pb-28 pt-16 sm:px-8 sm:py-16 lg:grid-cols-[1fr_1.05fr] lg:py-24" data-id="element-89">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} className="order-2 max-w-2xl lg:order-1" data-id="element-90">
            <p className="mb-6 text-xs font-bold tracking-[0.2em] text-[#6f8061]" data-id="element-91">
              BIENESTAR QUE SE SIENTE TODOS LOS DÍAS
            </p>
            <h1 className="font-display text-4xl leading-[1.08] text-[#2d3b2c] sm:text-5xl lg:text-6xl" data-id="element-92">
              Tu sistema completo para transformar tu alimentación{' '}
              <em className="font-normal" data-id="element-93">sin dietas extremas.</em>
            </h1>
            <p className="mt-7 max-w-xl text-lg leading-8 text-[#606b5d]" data-id="element-94">
              Aprende paso a paso a comer saludable de una forma práctica,
              deliciosa y sostenible. Más de 550 recetas, planes completos y
              guías para cuidar tu salud durante toda la vida.
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-95">
              <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-14 items-center justify-center rounded-full bg-[#405a3b] px-7 text-sm font-bold tracking-[0.06em] text-white transition-colors hover:bg-[#30452e]" data-id="element-96">
                QUIERO MI SISTEMA COMPLETO{' '}
                <ArrowRightIcon className="ml-2" size={17} data-id="element-97" />
              </a>
              <a href="#incluye" className="inline-flex min-h-14 items-center justify-center rounded-full border border-[#758171] bg-white/70 px-7 text-sm font-semibold text-[#40503d] transition-colors hover:bg-white" data-id="element-98">
                Ver todo lo que incluye{' '}
                <ArrowDownIcon className="ml-2" size={16} data-id="element-99" />
              </a>
            </div>
            <div className="mt-9 flex flex-wrap gap-x-6 gap-y-3 text-xs text-[#52604e]" data-id="element-100">
              <span className="flex items-center gap-1 text-[#9c7428]" data-id="element-101">
                <StarIcon fill="currentColor" size={15} data-id="element-102" />
                <StarIcon fill="currentColor" size={15} data-id="element-103" />
                <StarIcon fill="currentColor" size={15} data-id="element-104" />
                <StarIcon fill="currentColor" size={15} data-id="element-105" />
                <StarIcon fill="currentColor" size={15} data-id="element-106" />
              </span>
              <span data-id="element-107">Miles de recetas saludables</span>
              <span data-id="element-108">Acceso inmediato</span>
              <span data-id="element-109">Todos tus dispositivos</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.15
        }} className="relative order-1 mx-auto w-full max-w-xl lg:order-2" data-id="element-110">
            <div className="absolute -inset-5 bg-[#e4e4d5]/75" data-id="element-111" />
            <img src="https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=1100&q=85" alt="Ingredientes naturales sobre mesa de madera clara" className="relative h-[390px] w-full object-cover sm:h-[500px]" data-id="element-112" />
            <div className="absolute inset-x-[10%] bottom-[-15px] flex items-end justify-center gap-2 sm:gap-4" data-id="element-113">
              {[['GUÍA PRINCIPAL', 'text-[#f8f5e9] bg-[#405a3b]'], ['DÉFICIT\nCALÓRICO', 'text-[#354a35] bg-[#d9ded0]'], ['COCINA\nANTIINFLAMATORIA', 'text-[#705f41] bg-[#eadfc8]'], ['PLANIFICADOR', 'text-[#fffdf6] bg-[#536a54]']].map(([title, colors], index) => <div key={title} className={`${colors} flex w-20 items-center justify-center px-1.5 py-3 text-center shadow-xl sm:w-28 sm:px-3 sm:py-7 ${index === 0 ? 'h-36 sm:h-48' : 'h-28 sm:h-40'}`} data-id="element-114">
                  <span className="block w-full break-words text-[7px] font-bold leading-[1.35] tracking-[0.08em] sm:text-[10px] sm:leading-4 sm:tracking-[0.12em]" data-id="element-115">
                    {title}
                    <span className="mt-2 block text-[6px] font-medium leading-[1.3] tracking-normal sm:text-[9px]" data-id="element-116">
                      CÓDIGO FITNESS™
                    </span>
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </section>

      <section id="sistema" className="relative overflow-hidden bg-[#fffefa] py-24 sm:py-32" data-id="element-117">
        <LeafIcon aria-hidden="true" className="absolute -left-8 top-24 h-28 w-28 rotate-[22deg] text-[#dce7d4]/55" strokeWidth={1} data-id="element-118" />
        <LeafIcon aria-hidden="true" className="absolute -right-5 bottom-28 h-32 w-32 -rotate-[35deg] text-[#e4eadc]/70" strokeWidth={1} data-id="element-119" />

        <div className="relative mx-auto max-w-7xl px-5 sm:px-8" data-id="element-120">
          <div className="grid gap-16 lg:grid-cols-[.82fr_1.18fr] lg:items-center lg:gap-20" data-id="element-121">
            <motion.figure initial={{
            opacity: 0,
            y: 18,
            rotate: -1
          }} whileInView={{
            opacity: 1,
            y: 0,
            rotate: -3
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.65
          }} className="relative mx-auto w-full max-w-[430px] lg:max-w-none" data-id="element-122">
              <div aria-hidden="true" className="absolute inset-x-8 bottom-0 h-12 rounded-full bg-[#6d7c61]/20 blur-2xl" data-id="element-123" />
              <img src="https://cdn.magicpatterns.com/uploads/p6eSw6NCw4ySwhkkY5xzYS/portada_codigo_f.png" alt="Portada del libro Guía Práctica Código Fitness para aprender a comer saludable sin pasar hambre" className="relative w-full rounded-sm shadow-[18px_28px_42px_rgba(47,59,43,0.28)]" data-id="element-124" />
            </motion.figure>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.6,
            delay: 0.08
          }} data-id="element-125">
              <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-126">
                TODO COMIENZA AQUÍ
              </p>
              <h2 className="font-display mt-5 max-w-3xl text-4xl leading-[1.08] text-[#2d3b2c] sm:text-5xl" data-id="element-127">
                Mucho más que un libro. Es el método que transformará tu forma
                de alimentarte para siempre.
              </h2>

              <div className="mt-7 max-w-3xl space-y-5 text-[15px] leading-7 text-[#63705f] sm:text-base" data-id="element-128">
                <p data-id="element-129">CÓDIGO FITNESS™ no fue creado para darte una dieta más.</p>
                <p data-id="element-130">
                  Fue diseñado para enseñarte, paso a paso, cómo comer saludable
                  sin pasar hambre, sin restricciones extremas y sin sentir que
                  estás haciendo un sacrificio.
                </p>
                <p data-id="element-131">
                  Aprenderás exactamente qué comer, cómo organizar tus comidas,
                  cómo preparar recetas deliciosas y cómo crear hábitos que
                  puedas mantener durante toda la vida.
                </p>
                <p data-id="element-132">
                  Es una guía práctica creada para acompañarte todos los días,
                  incluso si nunca antes has seguido un plan de alimentación.
                </p>
              </div>

              <div className="mt-8" data-id="element-133">
                <p className="mb-3 text-sm font-medium text-[#61725b]" data-id="element-134">
                  Acceso completo por{' '}
                  <span className="font-display text-2xl text-[#354a33]" data-id="element-135">
                    $29.99 USD
                  </span>
                </p>
                <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-14 items-center justify-center rounded-full bg-[#405a3b] px-7 text-sm font-bold tracking-[0.06em] text-white shadow-[0_10px_20px_rgba(48,69,46,0.14)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304a2d] hover:shadow-[0_14px_25px_rgba(48,69,46,0.2)]" data-id="element-136">
                  🍃 QUIERO COMENZAR MI TRANSFORMACIÓN
                </a>
                <p className="mt-3 text-xs text-[#70806b]" data-id="element-137">
                  🔒 Pago seguro • Acceso inmediato • Descarga digital
                </p>
              </div>

              <div className="mt-10 border-t border-[#dbe0d4] pt-8" data-id="element-138">
                <div className="flex items-start gap-4" data-id="element-139">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#e5eddf] text-[#4e6748]" data-id="element-140">
                    <LeafIcon size={20} strokeWidth={1.5} data-id="element-141" />
                  </span>
                  <div data-id="element-142">
                    <h3 className="font-display text-2xl text-[#354a33]" data-id="element-143">
                      Guía Principal CÓDIGO FITNESS™
                    </h3>
                    <p className="mt-2 font-medium text-[#52634d]" data-id="element-144">
                      Más de 55 páginas completamente ilustradas.
                    </p>
                    <p className="mt-3 max-w-2xl leading-7 text-[#657160]" data-id="element-145">
                      Aprenderás desde cero cómo transformar tu alimentación de
                      forma sencilla, práctica y sostenible.
                    </p>
                  </div>
                </div>

                <h4 className="mt-9 text-sm font-bold uppercase tracking-[0.14em] text-[#455b40]" data-id="element-146">
                  Lo que aprenderás
                </h4>
                <ul className="mt-5 grid gap-x-7 gap-y-3 sm:grid-cols-2" data-id="element-147">
                  {learningPoints.map(point => <li key={point} className="flex items-start gap-2.5 text-sm leading-6 text-[#5b6858]" data-id="element-148">
                      <CheckIcon className="mt-1 shrink-0 text-[#69845f]" size={15} strokeWidth={2} data-id="element-149" />
                      <span data-id="element-150">{point}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>
          </div>

          <div className="mx-auto mt-20 max-w-5xl border-l-2 border-[#859c78] bg-[#eff3e9] px-7 py-8 sm:px-10 sm:py-9" data-id="element-151">
            <div className="flex items-start gap-4" data-id="element-152">
              <LeafIcon className="mt-0.5 shrink-0 text-[#627a58]" size={24} strokeWidth={1.5} aria-hidden="true" data-id="element-153" />
              <p className="font-display max-w-4xl text-2xl leading-8 text-[#3e5439] sm:text-[27px]" data-id="element-154">
                No necesitas fuerza de voluntad. Solo necesitas un método claro
                que te enseñe exactamente qué hacer. Eso es exactamente lo que
                encontrarás dentro de CÓDIGO FITNESS™.
              </p>
            </div>
          </div>

          <div className="mt-16 grid border-y border-[#dfe4d8] sm:grid-cols-2 lg:grid-cols-4" data-id="element-155">
            {[['Más de 300', 'recetas saludables', ListChecksIcon], ['55+', 'páginas de contenido práctico', LeafIcon], ['30 días', 'calendario nutricional', CalendarDaysIcon], ['4 semanas', 'de menús completos', CalendarDaysIcon], ['Paso a paso', 'recetas claras para seguir', CheckIcon], ['Listas', 'inteligentes de compras', ListChecksIcon], ['Inmediato', 'acceso a tu sistema', CheckIcon], ['En todos lados', 'celular, tablet y computadora', MonitorSmartphoneIcon]].map(([value, label, Icon], index) => {
            const StatIcon = Icon as typeof LeafIcon;
            return <div key={label as string} className={`min-h-36 p-6 sm:p-7 ${index < 4 ? 'border-b border-[#dfe4d8] lg:border-b-0' : ''} ${index % 2 === 0 ? 'sm:border-r sm:border-[#dfe4d8] lg:border-r' : 'lg:border-r'} ${index === 3 || index === 7 ? 'lg:border-r-0' : ''}`} data-id="element-156">
                  <StatIcon className="text-[#6d8662]" size={21} strokeWidth={1.4} data-id="element-157" />
                  <p className="font-display mt-5 text-2xl text-[#3d5438]" data-id="element-158">
                    {value as string}
                  </p>
                  <p className="mt-1 text-sm leading-5 text-[#6a7567]" data-id="element-159">
                    {label as string}
                  </p>
                </div>;
          })}
          </div>

          <div className="mx-auto mt-16 max-w-4xl text-center" data-id="element-160">
            <p className="font-display text-2xl leading-9 text-[#40513e] sm:text-3xl" data-id="element-161">
              Este libro se convertirá en la guía que consultarás cada vez que
              tengas dudas sobre qué cocinar, cómo organizar tus comidas o cómo
              volver al camino de una alimentación saludable.
            </p>
            <p className="mt-6 text-base leading-7 text-[#667361]" data-id="element-162">
              No es un libro para leer una sola vez. Es una herramienta práctica
              para utilizar todos los días.
            </p>
          </div>
        </div>
      </section>
    </>;
}